import { render, staticRenderFns } from "./ConfirmStatusSwitch.vue?vue&type=template&id=2587a034&scoped=true&lang=pug"
import script from "./ConfirmStatusSwitch.vue?vue&type=script&lang=ts"
export * from "./ConfirmStatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmStatusSwitch.vue?vue&type=style&index=0&id=2587a034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587a034",
  null
  
)

export default component.exports